var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ig-ad-optimization" } }, [
    _c("div", { staticClass: "ad-optimization-container" }, [
      _c("div", { staticClass: "section" }, [
        _c(
          "div",
          { staticClass: "section-header" },
          [
            _c("h3", [_vm._v("CAPI Durumu")]),
            _vm._v(" "),
            _c("a-switch", {
              attrs: {
                checked: _vm.capiEnabled,
                "checked-children": "Aktif",
                "un-checked-children": "Pasif",
              },
              on: { change: _vm.toggleCapi },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.capiEnabled
          ? _c("div", { staticClass: "section-body" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { staticClass: "main-label" }, [
                    _vm._v("Bağlantı Yöntemi"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-radio-group",
                    {
                      staticClass: "radio-group",
                      on: { change: _vm.handleConnectionMethodChange },
                      model: {
                        value: _vm.connectionMethod,
                        callback: function ($$v) {
                          _vm.connectionMethod = $$v
                        },
                        expression: "connectionMethod",
                      },
                    },
                    [
                      _c(
                        "a-radio",
                        {
                          staticClass: "radio-item",
                          attrs: { value: "oauth" },
                        },
                        [
                          _c("span", { staticClass: "radio-text" }, [
                            _vm._v("Connect through Meta"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-radio",
                        {
                          staticClass: "radio-item",
                          attrs: { value: "manual" },
                        },
                        [
                          _c("span", { staticClass: "radio-text" }, [
                            _vm._v("With Dataset and Token"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.connectionMethod === "oauth"
                ? _c(
                    "div",
                    { staticClass: "oauth-section" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: {
                            primary: "",
                            disabled: _vm.oauthLoading,
                            icon: "link",
                          },
                          on: { click: _vm.startOauth },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.oauthLoading
                                  ? "Bağlanıyor..."
                                  : "Meta ile Bağlan"
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.datasets.length > 0
                        ? _c(
                            "div",
                            { staticClass: "dataset-section" },
                            [
                              _c("label", { staticClass: "main-label" }, [
                                _vm._v("Dataset Seçimi"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "Bir dataset seçin" },
                                  on: { change: _vm.handleDatasetChange },
                                  model: {
                                    value: _vm.selectedDatasetId,
                                    callback: function ($$v) {
                                      _vm.selectedDatasetId = $$v
                                    },
                                    expression: "selectedDatasetId",
                                  },
                                },
                                _vm._l(_vm.datasets, function (dataset) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: dataset.id,
                                      attrs: { value: dataset.id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(dataset.name) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "SupsisButton",
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    disabled: _vm.creatingDataset,
                                    icon: "add",
                                  },
                                  on: { click: _vm.createNewDataset },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.creatingDataset
                                          ? "Oluşturuluyor..."
                                          : "Yeni Dataset Oluştur"
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.connectionMethod === "manual"
                ? _c("div", { staticClass: "manual-section" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "main-label" }, [
                          _vm._v("Dataset ID"),
                        ]),
                        _vm._v(" "),
                        _c("a-input", {
                          attrs: { placeholder: "Dataset ID'sini girin" },
                          on: { change: _vm.handleManualDatasetChange },
                          model: {
                            value: _vm.manualDatasetId,
                            callback: function ($$v) {
                              _vm.manualDatasetId = $$v
                            },
                            expression: "manualDatasetId",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "main-label" }, [
                          _vm._v("Access Token"),
                        ]),
                        _vm._v(" "),
                        _c("a-input", {
                          attrs: {
                            type: "password",
                            placeholder: "Access token'ı girin",
                          },
                          on: { change: _vm.handleManualTokenChange },
                          model: {
                            value: _vm.manualAccessToken,
                            callback: function ($$v) {
                              _vm.manualAccessToken = $$v
                            },
                            expression: "manualAccessToken",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasDatasetAndToken
                ? _c(
                    "div",
                    { staticClass: "test-section" },
                    [
                      _c(
                        "SupsisButton",
                        {
                          attrs: {
                            disabled: _vm.testing,
                            icon: "check_circle",
                          },
                          on: { click: _vm.testConnection },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.testing
                                  ? "Test Ediliyor..."
                                  : "Bağlantıyı Test Et"
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.testResult !== null
                        ? _c(
                            "span",
                            {
                              staticClass: "test-result",
                              class: _vm.testResult ? "success" : "error",
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.testResult ? "check_circle" : "cancel"
                                  )
                                ),
                              ]),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.testResult
                                      ? "Bağlantı başarılı"
                                      : "Bağlantı başarısız"
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasDatasetAndToken
                ? _c("div", { staticClass: "auto-events-section" }, [
                    _c("h4", [_vm._v("Otomatik Event Gönderimi")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "event-toggles" },
                      _vm._l(_vm.eventTypes, function (event) {
                        return _c(
                          "div",
                          { key: event.key, staticClass: "event-toggle" },
                          [
                            _c("a-switch", {
                              attrs: {
                                checked: _vm.autoEvents[event.key],
                                size: "small",
                              },
                              on: {
                                change: function (val) {
                                  return _vm.toggleAutoEvent(event.key, val)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "event-info" }, [
                              _c("span", { staticClass: "event-label" }, [
                                _vm._v(_vm._s(event.label)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "event-desc" }, [
                                _vm._v(_vm._s(event.description)),
                              ]),
                            ]),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-box" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                            Meta üzerinden bağlantı kurmak için tekrar yetkilendirme yapmanız gerekiyor. Bu işlem\n                            mevcut kanalınızı bozmaz, sadece ek izinler ekler.\n                        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }